import type { Scenario } from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { scenarioNodeSchema } from './scenarioNodeSchema'
import { z } from 'zod'

export const scenarioSchema = z.object({
  id: z.number().int().min(-2147483648).max(2147483647),
  workspace_id: z.number().int().min(0).max(2147483647),
  created_at: z.string(),
  updated_at: z.string(),
  name: z.string(),
  version_name: z.string().nullable(),
  nodes: z.array(z.lazy(() => scenarioNodeSchema)),
}) as unknown as ToZod<Scenario>

export type ScenarioSchema = Scenario